namespace GeniuzPOS.PosShift {
    export namespace LookupTaxInvoiceforVatRefundService {
        export const baseUrl = 'PosShift/LookupTaxInvoiceforVatRefund';

        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<LookupTaxInvoiceforVatRefundRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<LookupTaxInvoiceforVatRefundRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Retrieve = "PosShift/LookupTaxInvoiceforVatRefund/Retrieve",
            List = "PosShift/LookupTaxInvoiceforVatRefund/List"
        }

        [
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>LookupTaxInvoiceforVatRefundService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
